import {request} from "../../base/HTTP";
import HttpMethod from "../../constants/HttpMethod";

export async function getPermissionAdministration(data){
    return await request('/api/permission_administration/', data)
}

export async function getPermissionNavigation(){
    return await request('/api/permission_administration/navigation/')
}